// extracted by mini-css-extract-plugin
module.exports = {"bone":"bone--292cd","gradientBG":"gradientBG--ebcc7"};